export const WHO_WE_ARE: string = "Who we are"

export const WHAT_KIND_OF_PERSONAL_INFORMATION: string =
  "What kind of personal information do we collect"

export const WHO_MAY_WE_DISCLOSE_PERSONAL_INFORMATION: string =
  "Who may we disclose personal information to"

export const HOW_DO_WE_OBTAIN_YOUR_CONSENT: string =
  "How do we obtain your consent"

export const MANAGEMENT_OF_PERSONAL_INFORMATION: string =
  "Management of personal information"

export const HOW_DO_WE_STORE_PERSONAL_INFORMATION: string =
  "How do we store personal information and for how long"

export const HOW_DO_WE_USE_THE_PERSONAL_INFORMATION: string =
  "How do we use the personal information"

export const THE_PERSONAL_INFORMATION_WE_HOLD_ABOUT_YOU: string =
  "The personal information we hold about you"

export const WHAT_IS_A_COOKIE: string =
  "What is a cookie and how do we use cookies"

export const TECHNOLOGY_IMPROVEMENTS: string = "Technology improvements"

export const LINKS_TO_THIRD_PARTY_WEBSITES: string =
  "Links to third party websites"

export const WHAT_IF_YOU_HAVE_A_COMPLAINT: string =
  "What if you have a complaint"

export const CONTACT_US: string = "Contact Us"

export const PRIVACY_POLICY_CONST: string = "Privacy Policy"

export const ACCEPTABLE_USE_POLICY: string = "Acceptable Use Policy"

export const DATA_PROCESSING_ADDENDUM: string = "Data Processing Addendum"

export const SUPPORT_POLICY: string = "Support Policy"

export const UNAUTH_LEGAL_SECTIONS: string[] = [PRIVACY_POLICY_CONST]
export const AUTH_LEGAL_SECTIONS: string[] = [
  ACCEPTABLE_USE_POLICY,
  DATA_PROCESSING_ADDENDUM,
  SUPPORT_POLICY,
]

export const KAIZEN_HUB_ROUTE = "Kaizen Hub"

export const LEGAL_CONST: string = "legal"

export const PRIVACY_POLICY_SECTIONS: string[] = [
  WHO_WE_ARE,
  WHAT_KIND_OF_PERSONAL_INFORMATION,
  WHO_MAY_WE_DISCLOSE_PERSONAL_INFORMATION,
  HOW_DO_WE_OBTAIN_YOUR_CONSENT,
  MANAGEMENT_OF_PERSONAL_INFORMATION,
  HOW_DO_WE_STORE_PERSONAL_INFORMATION,
  HOW_DO_WE_USE_THE_PERSONAL_INFORMATION,
  THE_PERSONAL_INFORMATION_WE_HOLD_ABOUT_YOU,
  WHAT_IS_A_COOKIE,
  TECHNOLOGY_IMPROVEMENTS,
  LINKS_TO_THIRD_PARTY_WEBSITES,
  WHAT_IF_YOU_HAVE_A_COMPLAINT,
  CONTACT_US,
].map((el) => `/${PRIVACY_POLICY_CONST}/${el}`)

export const PRIVACY_POLICY: {} = {
  [PRIVACY_POLICY_CONST]: PRIVACY_POLICY_SECTIONS,
}

export const TERMS_AND_CONDITIONS = "Terms and Conditions"
export const TERMS_AND_CONDITIONS_URL = "/foundation_v1/me/terms-and-conditions"
